/* eslint-disable camelcase */
import {
  Accordion,
  AccordionContent,
  AccordionDropDownContent,
  Card,
  CardTitle,
  StatusType,
} from '@serodigital/ui-components';
import * as React from 'react';
import { DataPointCommissioningCheckType, PeripheralHealthCheckType } from '../../../../../shared/api-clients/gql';
import { formatPeripheralDescription } from '../../../../../shared/helpers/peripheralHelpers';
import { DataPacketModal } from '../../../components/modal/dataPacketModal';
import { DatapointCheck } from './datapointcheck';
import { PeripheralStatus } from './peripheralStatus';

interface IProps {
  peripherals: PeripheralHealthCheckType[];
  canViewPeripheralData: boolean;
  onlineStatus?: string;
}

function generateType(onlineStatus: string, healthcheck: string, datapointChecks: DataPointCommissioningCheckType[]) {
  if (onlineStatus === 'Offline') return 'offline';

  if (datapointChecks?.some((check) => check.status === 'failed')) return 'onlineWithDataPointCheckError';

  switch (healthcheck) {
    case 'passed_healthcheck':
      return 'success';
    case 'pending_healthcheck':
      return 'waiting';
    case 'failed_healthcheck':
      return 'failed';
    default:
      return 'warning';
  }
}

export function Peripheral({ onlineStatus, peripherals, canViewPeripheralData }: IProps) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [data, setData] = React.useState(null);

  const handleCloseModal = () => setIsModalOpen(false);

  function generateList() {
    if (peripherals?.length === 0) {
      return (
        <PeripheralStatus
          data-qa="peripheral-empty-status"
          label={'There are no peripherals attached to this BEE id'}
          type={'warning'}
          canViewData={canViewPeripheralData}
        />
      );
    }

    return peripherals?.map(({ device_type, zone_id, status, data, datapoint_checks }) => {
      return (
        <>
          <Accordion>
            <AccordionContent className='sero-w-full' data-qa={`ac-${device_type}`}>
              <PeripheralStatus
                key={`${device_type} - ${zone_id}`}
                data-qa="peripheral-status"
                type={generateType(onlineStatus, status, datapoint_checks) as StatusType}
                label={`${formatPeripheralDescription(zone_id, device_type)}`}
                peripheralData={data && JSON.parse(data || JSON.stringify({}))}
                canViewData={canViewPeripheralData}
              />
            </AccordionContent>
            <AccordionDropDownContent className='bg-[#FBFAFA] mb-24 p-16 rounded-md flex flex-col'>
              <DatapointCheck
                canViewPeripheralData={canViewPeripheralData}
                data={data}
                datapoint_checks={datapoint_checks}
                onlineStatus={onlineStatus}
                setData={setData}
                setIsModalOpen={setIsModalOpen}
              />
            </AccordionDropDownContent>
          </Accordion>
        </>
      );
    });
  }
  return (
    <div className="peripherals w-1/2">
      <Card data-qa="peripherals-card" CardTitle={<CardTitle title={'Peripheral Status Check'} />}>
        {generateList()}
        <DataPacketModal
          isOpen={isModalOpen}
          title={data && `${formatPeripheralDescription(JSON.parse(data)?.zone_id, JSON.parse(data)?.device_type)}`}
          handleCloseModal={handleCloseModal}
          peripheralData={data && JSON.parse(data)}
        />
      </Card>
    </div>
  );
}
